import G6 from '@antv/g6';
import { getFlowRecallEdges, executeBatch } from '../utils';
import { ItemState, GraphNodeEvent, GraphEdgeEvent, GraphCanvasEvent } from '../constants';
import { Node, Edge, Behavior, GraphEvent } from '../types';

interface RecallEdgeBehavior extends Behavior {
  /** Current highlighted edge ids */
  edgeIds: string[];
  /** Set highlight */
  setHighLightState(edges: Edge[]): void;
  /** Clear highlight */
  clearHighLightState(): void;
  /** Handle node click */
  handleNodeClick(e: GraphEvent): void;
  /** Handle edge click */
  handleEdgeClick(e: GraphEvent): void;
  /** Handle canvas click */
  handleCanvasClick(e: GraphEvent): void;
}

const recallEdgeBehavior: RecallEdgeBehavior = {
  edgeIds: [],

  getEvents() {
    return {
      [GraphNodeEvent.onNodeClick]: 'handleNodeClick',
      [GraphEdgeEvent.onEdgeClick]: 'handleEdgeClick',
      [GraphCanvasEvent.onCanvasClick]: 'handleCanvasClick',
    };
  },

  setHighLightState(edges: Edge[]) {
    const { graph } = this;

    this.clearHighLightState();

    executeBatch(graph, () => {
      edges.forEach((item) => {
        graph?.setItemState(item, ItemState.HighLight, true);
      });
    });

    this.edgeIds = edges.map((edge) => edge.get('id'));
  },

  clearHighLightState() {
    const { graph } = this;

    executeBatch(graph, () => {
      this.edgeIds.forEach((id) => {
        const item = graph?.findById(id);

        if (item && !item.destroyed) {
          graph?.setItemState(item, ItemState.HighLight, false);
        }
      });
    });

    this.edgeIds = [];
  },

  handleNodeClick({ item }) {
    const { graph } = this;

    /**
     * If we begin to support TreeGraphs, we'll need to add an alterative way of
     * getting those edges
     * See line 71 of the following:
     * https://github.com/alibaba/GGEditor/blob/master/src/components/Graph/behavior/recallEdge.ts
     */
    const edges: Edge[] = getFlowRecallEdges(graph, item as Node) || [];

    this.setHighLightState(edges);
  },

  handleEdgeClick() {
    this.clearHighLightState();
  },

  handleCanvasClick() {
    this.clearHighLightState();
  },
};

G6.registerBehavior('recall-edge', recallEdgeBehavior);
